import React, { useCallback, useEffect, useRef, useState } from "react";
import { ShimmerSocialPost, ShimmerThumbnail } from "react-shimmer-effects";
import axios, { enableAlgoKey } from "../../API/axios";
import {
  getUserConfig,
  getEmojiDDL,
  getOwnInfo,
  getProfilePercentage,
  syncAccountAlgoData,
} from "../../Services/apiService";
import { post, svg, people } from "../../config/imagesLink";
import AddPost from "./AddPost";
import PostInteractionModal from "./PostInteractionModal";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import ImageSliderModal from "./ImageSliderModal";
import Loading from "../Blogs/Loading";
import moment from "moment";
import PostEngagement from "./PostEngagement";
import PostComment from "./PostComment";
import SuccessToast from "../SuccessToast";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import Comment from "./Comment";
import LikesDetails from "./LikesDetails";
import { warning } from "framer-motion";
import PublicSharpIcon from "@mui/icons-material/PublicSharp";
import GroupSharpIcon from "@mui/icons-material/GroupSharp";
import LockSharpIcon from "@mui/icons-material/LockSharp";
import TuneSharpIcon from "@mui/icons-material/TuneSharp";
import ReplyAllOutlinedIcon from '@mui/icons-material/ReplyAllOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";

import { PostFeedSkeleton } from "@skeleton";
import PostComponent from "./PostComponent";
import InfoSharpIcon from "@mui/icons-material/InfoSharp";
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import LanguageIcon from '@mui/icons-material/Language';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Advertisement from "./PostAdvertisement";
import ThumbUpSharpIcon from "@mui/icons-material/ThumbUpSharp";
import ArrowLeftSharpIcon from "@mui/icons-material/ArrowLeftSharp";
import ArrowRightSharpIcon from "@mui/icons-material/ArrowRightSharp";
import RecommendationAction from "../Connections/RecommendationAction";
import CompanyInteraction from "../Companies/CompanyInteraction";
import PostVideoCommon from "../PersonalProfile/PostVideoCommon";
import UserAuth from "../Auth/UserAuth";
import useNewsFeedStore from "./useNewsFeedStore";
import ArrowForwardSharpIcon from "@mui/icons-material/ArrowForwardSharp";
import { Tooltip } from "@mui/material";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import "moment/locale/ar";
import "moment/locale/hi";
import "moment/locale/en-gb";
import { Helmet } from "react-helmet";
import { mountAdSenseInContainer } from "../../utility/googleAds";

const getAlgoStorageValues = () => ({
  loggedInUser_EngagedUsersIDs: localStorage.getItem("loggedInUser_EngagedUsersIDs"),
  peopleRecommendationsIds: localStorage.getItem("peopleRecommendationsIds"),
  engagedUsersMostEngagedPostIds: localStorage.getItem("engagedUsersMostEngagedPostIds"),
  jobRecommendationsIds: localStorage.getItem("jobRecommendationsIds"),
  allPostsIds: localStorage.getItem("allPostsIds"),
  companyRecommendationsIds: localStorage.getItem("companyRecommendationsIds"),
  restrictedViewerToken: localStorage.getItem("restrictedViewerToken"),
  followedCompaniesIDs: localStorage.getItem("followedCompaniesIDs"),
  followedUsersIDs: localStorage.getItem("followedUsersIDs"),
  ownedMostEngagedPostIds: localStorage.getItem("ownedMostEngagedPostIds"),
  followedCompaniesPostsIds: localStorage.getItem("followedCompaniesPostsIds"),
});

const isMissingStorageValue = (value) =>
  value == null || value === "null" || (typeof value === "string" && value.trim() === "");

const { pin } = svg;

const NewsfeedNew = ({ setIsVideoProcessing, setProgress, SyncAccount }) => {

  const { t } = useTranslation();

  const { updateIsNewsPageLoaded, setIsNewsFeedApiLoading } = useNewsFeedStore();
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  const language = localStorage.getItem("Lang");
  const localeMap = {
    en: "en",
    ar: "ar",
    hi: "hi",
  };

  const locale = localeMap[language] || "en";

  const isDark = localStorage.getItem("isDark");
  const [algoStorage, setAlgoStorage] = useState(() => getAlgoStorageValues());
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [postList, setPostList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // total pages for the initial phase (sortType = 1). Once we've fetched
  // through all pages in this phase, subsequent requests will use sortType = 2
  const [firstPhaseTotalPages, setFirstPhaseTotalPages] = useState(null);
  const [secondPhaseTotalPages, setSecondPhaseTotalPages] = useState(null);
  const [isError, setIsError] = useState(false);
  const [dLike, setDLike] = useState(0);
  const [isLiked, setIsLiked] = useState(false);
  const [postIdLikeData, setPostIdLikeData] = useState([]);

  const [data, setData] = useState(null);
  const [showUserAuthModal, setShowUserAuthModal] = useState(false);
  const [activeVideoId, setActiveVideoId] = useState(null);
  const userUid = localStorage.getItem("userUid");
  const [nextBatchLoading, setNextBatchLoading] = useState("");
  const [restrictedViewerToken, setRestrictedViewerToken] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const visibleVideoRef = useRef(null);
  const sectionRef = useRef(null);
  const isFetchingRef = useRef(false);
  const syncAccountIntervalRef = useRef(null);
  const hasStartedSyncAccountScheduleRef = useRef(false);

  const {
    loggedInUser_EngagedUsersIDs,
    peopleRecommendationsIds,
    engagedUsersMostEngagedPostIds,
    jobRecommendationsIds,
    allPostsIds,
    companyRecommendationsIds,
    restrictedViewerToken: restrictedViewerTokens,
    followedCompaniesIDs,
    followedUsersIDs,
    ownedMostEngagedPostIds,
    followedCompaniesPostsIds,
  } = algoStorage;

  const refreshAlgoStorage = useCallback(() => {
    setAlgoStorage(getAlgoStorageValues());
  }, []);

  // Cleanup: Cancel all pending requests on component unmount
  useEffect(() => {
    return () => {
      Object.values(abortControllersRef.current).forEach(controller => {
        if (controller) controller.abort();
      });

      if (syncAccountIntervalRef.current) {
        clearInterval(syncAccountIntervalRef.current);
      }
    };
  }, []);

  const handleCloseUserAuthModal = () => {
    setShowUserAuthModal(false);
    document.body.classList.remove('modal-open');
  };



  useEffect(() => {
    if (!showUserAuthModal) {
      document.body.classList.remove('modal-open');
    }
  }, [showUserAuthModal]);

  // Show toast if navigated here with toast state (e.g., after login)
  useEffect(() => {
    if (location && location.state && location.state.toastMessage) {
      setToastMessage(location.state.toastMessage);
      setShowToast(true);
      // clear history state so toast doesn't reappear on refresh
      try {
        window.history.replaceState({}, document.title);
      } catch (e) {
        // ignore
      }
    }
  }, [location]);

  // -------------------------------------------------------------------------
  const { setIsNewsPageLoaded } = useNewsFeedStore();

  useEffect(() => {
    setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

    return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
  }, [setIsNewsPageLoaded]);

  // -------------------------------------------------------------------------


  const adContainerRef = useRef(null);
  const adContainerRef1 = useRef(null);
  const abortControllersRef = useRef({});
  const cachedEmojiRef = useRef(null);

  const refreshAds = () => {
    mountAdSenseInContainer(adContainerRef.current, {
      adSlot: "9135916775",
      style: "display: block; width: 100%; max-width: 250px; min-height: 50px; margin: 0 auto;",
    });
    mountAdSenseInContainer(adContainerRef1.current, {
      adSlot: "4907911040",
      style: "display: block; width: 100%; max-width: 250px; min-height: 50px; margin: 0 auto;",
    });
  };

  useEffect(() => {
    refreshAds();
  }, []);

  const runSyncAccount = useCallback(async () => {
    if (!sessionId) {
      return;
    }

    try {
      const algoData = await syncAccountAlgoData();
      if (algoData) {
        localStorage.setItem("engagedUsersMostEngagedPostIds", algoData.engagedUsersMostEngagedPostIds);
        localStorage.setItem("loggedInUser_EngagedUsersIDs", algoData.loggedInUser_EngagedUsersIDs);
        localStorage.setItem("peopleRecommendationsIds", algoData.peopleRecommendationsIds);
        localStorage.setItem("jobRecommendationsIds", algoData.jobRecommendationsIds);
        localStorage.setItem("companyRecommendationsIds", algoData.companyRecommendationsIds);
        localStorage.setItem("allPostsIds", algoData.allPostsIds);
        localStorage.setItem("connectedUsersIDs", algoData.connectedUsersIDs || null);
        localStorage.setItem("followedCompaniesIDs", algoData.followedCompaniesIDs || null);
        localStorage.setItem("followedUsersIDs", algoData.followedUsersIDs || null);
        localStorage.setItem("followedCompaniesPostsIds", algoData.followedCompaniesPostsIds || null);
        localStorage.setItem("ownedMostEngagedPostIds", algoData.ownedMostEngagedPostIds);
        localStorage.setItem("ownedAllPostIds", algoData.ownedAllPostIds);
        localStorage.setItem("restrictedViewerToken", algoData.restrictedViewerToken);
        refreshAlgoStorage();
      }
    } catch (error) {
      console.error("SyncAccount failed in Newsfeed:", error);
    }
  }, [refreshAlgoStorage, sessionId]);

  const startSyncAccountSchedule = useCallback(() => {
    if (!sessionId || typeof SyncAccount !== "function" || hasStartedSyncAccountScheduleRef.current) {
      return;
    }

    hasStartedSyncAccountScheduleRef.current = true;
    runSyncAccount();

    syncAccountIntervalRef.current = setInterval(() => {
      runSyncAccount();
    }, 60 * 60 * 1000);
  }, [SyncAccount, runSyncAccount, sessionId]);

  const AllPostList = async (pageNumber, currentSortType) => {
    const data = {
      deviceType: "Web",
      pageNumber,
      pageSize: 6,
      sortType: currentSortType,
      postID: null,
      // postID: 6626,
      // postID: 6505,
      // postID: 6340,
      restrictedViewerToken: restrictedViewerTokens,
      loggedInUser_EngagedUsersIDs: loggedInUser_EngagedUsersIDs || null,
      engagedUsersMostEngagedPostIds: engagedUsersMostEngagedPostIds || null,
      allPostsIds: allPostsIds || null,
      enableAlgo: enableAlgoKey,
      followedCompaniesIDs: followedCompaniesIDs || null,
      followedCompaniesPostsIds: followedCompaniesPostsIds || null,
      ownedMostEngagedPostIds: ownedMostEngagedPostIds || null,
      langKey: language === "en" ? "" : language,

    };

    try {
      setLoading(true);
      setNextBatchLoading(true);
      const resData = await axios.post(`Feature/NewsFeeds`, data);

      const totalPagesResp = resData.data.responseData.paging.totalPages;
      setTotalPages(totalPagesResp);
      if (currentSortType === 1) {
        setFirstPhaseTotalPages(totalPagesResp);
      } else {
        setSecondPhaseTotalPages(totalPagesResp);
      }
      const newPosts = resData.data.responseData.dataList;
      console.log("NewPostList===>", newPosts)
      const currentScroll = window.scrollY;
      setPostList((prev) => {
        const postSet = new Set(
          prev.map((post) => `${post.postInfo.postId}-${post.__sortTypePhase || 1}`)
        );
        const uniqueNewPosts = newPosts
          .map((post) => ({
            ...post,
            __sortTypePhase: currentSortType,
          }))
          .filter((post) => !postSet.has(`${post.postInfo.postId}-${post.__sortTypePhase}`));

        setTimeout(() => {
          window.scrollTo({ top: currentScroll });
        }, 50);

        setRestrictedViewerToken(resData?.data?.responseData?.restrictedViewerToken);
        // localStorage.setItem("restrictedViewerToken-video", resData?.data?.responseData?.restrictedViewerToken);

        return [...prev, ...uniqueNewPosts];
      });
      if (pageNumber === 1 && sessionId) {
        userConfig();
        startSyncAccountSchedule();
      }

      if (!newPosts || newPosts.length === 0) {
        if (currentSortType === 1) {
          setSortType(2);
          setPage(1);
          setHasMoreData(true);
        } else {
          setHasMoreData(false);
        }
      } else if (currentSortType === 2 && pageNumber >= totalPagesResp) {
        setHasMoreData(false);
      } else {
        setHasMoreData(true);
      }
      setNextBatchLoading(false);

    } catch (error) {
      if (error.response && error.response.status === 404) {
        setIsError(true);
      } else {
        console.error(error);
      }
      setNextBatchLoading(false);
    } finally {
      if (pageNumber === 1) {
        setIsLoading(false);
        updateIsNewsPageLoaded(true);
      }
      setTimeout(() => {
        setIsNewsFeedApiLoading(false);
      }, 1000);
    }
  };


  const [hasMoreData, setHasMoreData] = useState(true);

  useEffect(() => {
    if (hasMoreData) {
      setIsNewsFeedApiLoading(true);
      AllPostList(page, sortType);

      const cyclePage = page % 6 === 0 ? 6 : page % 6;
      const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
      if (restrictedViewerToken) {
        switch (cyclePage) {
          case 2:
            getPeopleRecommendation();
            break;
          case 4: 
            getJobRecommendation();
            break;
          case 6: 
            getCompanyRecommendation();
            break;
          default:
            break;
        }
      }
    }
  }, [page, sortType]);

  const getPostListWithAds = (posts) => {
    const result = [];
    posts.forEach((post, index) => {
      result.push(post);
      // Insert different components after every 12 posts
      if ((index + 1) % 6 === 0) {
        const pageIndex = Math.floor((index + 1) / 6);
        if (pageIndex % 2 === 1) {
          result.push({ isAd: true });
        } else if (pageIndex % 3 === 2) {
          result.push({ isPeopleRecommendation: true });
        } else if (pageIndex % 3 === 1) {
          result.push({ isJobRecommendation: true });
        } else if (pageIndex % 3 === 0) {
          result.push({ isCompanyRecommendation: true });
        }
      }
    });
    return result;
  };

  const postsWithAds = getPostListWithAds(postList);

  const handleInfiniteScroll = useCallback(async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        // don't attempt to load more if we've reached the end
        if (!hasMoreData) return;

        setLoading(true);
        const isLoading = useNewsFeedStore.getState().isNewsFeedApiLoading;
        console.log("Is News Feed API Loading:-", isLoading);
        if (!isLoading) {
          if (sortType === 1 && firstPhaseTotalPages && page >= firstPhaseTotalPages) {
            setSortType(2);
            setPage(1);
            return;
          }

          if (sortType === 2 && secondPhaseTotalPages && page >= secondPhaseTotalPages) {
            setHasMoreData(false);
            return;
          }

          setPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [firstPhaseTotalPages, hasMoreData, page, secondPhaseTotalPages, sortType]);

  useEffect(() => {
    window.addEventListener("scroll", handleInfiniteScroll);
    return () => window.removeEventListener("scroll", handleInfiniteScroll);
  }, [handleInfiniteScroll]);


  const updateLikeCount = (postId, delta) => {
    setPostList((prev) =>
      prev.map((post) =>
        post.postInfo.postId === postId
          ? {
            ...post,
            postInfo: {
              ...post.postInfo,
              likeCount: post.postInfo.likeCount + delta,
            },
          }
          : post
      )
    );
  };

  const updatePostLike = (postId, delta, isLikedStatus, likedType) => {
    setPostList((prev) =>
      prev.map((post) => {
        if (post.postInfo.postId === postId) {
          // const newLikeCount = Math.max(0, post.postInfo.likeCount + delta);

          return {
            ...post,
            postInfo: {
              ...post.postInfo,
              // likeCount: newLikeCount,
              postActionsInfo: {
                ...post.postInfo.postActionsInfo,
                isLiked: isLikedStatus,
                likedType: likedType,
              },
            },
          };
        }
        return post;
      })
    );
  };

  const updateCommentLike = (postId, commentId, action, likeType = null) => {
    setPostList((prevList) =>
      prevList.map((item) => {
        if (item?.postInfo?.postId !== postId) return item;

        return {
          ...item,
          postInfo: {
            ...item.postInfo,
            comments: (item.postInfo.comments || []).map((c) => {
              const commentKey = c?.pstCmntId ?? c?.commentId;
              if (String(commentKey) !== String(commentId)) return c;

              if (action === "like") {
                return {
                  ...c,
                  likeCount: (c.likeCount || 0) + 1,
                  isLiked: true,
                  likedType: likeType,
                };
              }

              if (action === "unlike") {
                return {
                  ...c,
                  likeCount: Math.max((c.likeCount || 1) - 1, 0),
                  isLiked: false,
                  likedType: null,
                };
              }

              if (action === "change") {
                return {
                  ...c,
                  isLiked: true,
                  likedType: likeType, // count same, type replace
                };
              }

              return c;
            }),
          },
        };
      })
    );
  };


  const updateCommentCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post?.postInfo?.postId === postId
          ? {
            ...post,
            postInfo: {
              ...post.postInfo,
              commentCount: Math.max((post?.postInfo?.commentCount || 0) + change, 0),
            },
          }
          : post
      )
    );
  };


  const updateReplyCommentLike = (postId, commentId, replyId, action, likeType = null) => {
    setPostList((prevList) =>
      prevList.map((post) => {
        // postId check
        if (post.postInfo.postId !== postId) return post;

        return {
          ...post,
          postInfo: {
            ...post.postInfo,
            comments: (post.postInfo.comments || []).map((c) => {
              // commentId check
              const commentKey = c?.pstCmntId ?? c?.commentId;
              if (String(commentKey) !== String(commentId)) return c;

              return {
                ...c,
                commentsReplies: (c.commentsReplies || []).map((reply) => {
                  const replyKey = reply?.pstCmntRplyId ?? reply?.replyCommentId;
                  if (String(replyKey) !== String(replyId)) return reply;

                  if (action === "like") {
                    return {
                      ...reply,
                      isLiked: true,
                      likeCount: (reply.likeCount || 0) + 1,
                      likedType: likeType,
                    };
                  }

                  if (action === "unlike") {
                    return {
                      ...reply,
                      isLiked: false,
                      likeCount: reply.likeCount > 0 ? reply.likeCount - 1 : 0,
                      likedType: null,
                    };
                  }

                  if (action === "change") {
                    return {
                      ...reply,
                      isLiked: true,
                      likedType: likeType,
                    };
                  }

                  return reply;
                }),
              };
            }),
          },
        };
      })
    );
  };

  const updateShareCount = (postId, change) => {
    setPostList((prev) =>
      prev.map((post) =>
        post?.postInfo?.postId === postId
          ? {
            ...post,
            postInfo: {
              ...post.postInfo,
              shareCount: Math.max((post?.postInfo?.shareCount || 0) + change, 0),
            },
          }
          : post
      )
    );
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [singlePostContent, setSinglePostContent] = useState("");
  console.log("singlePostContent", singlePostContent);
  const [singlepostId, setSinglePostId] = useState("");
  const [ispostmodalOpen, setIspostmodalOpen] = useState(false);


  const [sliderSettings, setSliderSettings] = useState({
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  });

  const [mediaFiles, setMediaFiles] = useState([]);

  const mergePostData = useCallback((existingPost, incomingPostData, incomingComments = null) => {
    if (!incomingPostData) return existingPost;

    if (incomingPostData?.postInfo) {
      return {
        ...existingPost,
        ...incomingPostData,
        postInfo: {
          ...existingPost?.postInfo,
          ...incomingPostData.postInfo,
          comments: Array.isArray(incomingComments)
            ? incomingComments
            : Array.isArray(incomingPostData?.postInfo?.comments)
              ? incomingPostData.postInfo.comments
              : existingPost?.postInfo?.comments || [],
        },
      };
    }

    return {
      ...existingPost,
      postInfo: {
        ...existingPost?.postInfo,
        ...incomingPostData,
        comments: Array.isArray(incomingComments)
          ? incomingComments
          : Array.isArray(incomingPostData?.comments)
            ? incomingPostData.comments
            : existingPost?.postInfo?.comments || [],
      },
    };
  }, []);

  const syncPostInFeed = useCallback(async (postIdToSync) => {
    if (!postIdToSync) return;

    try {
      const response = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${postIdToSync}&RestrictedViewerToken=${restrictedViewerToken || restrictedViewerTokens || ""}&langKey=${language === "en" ? "" : language}`
      );

      const latestPostData = response?.data?.responseData?.postInfo;
      if (!latestPostData) return;

      setPostList((prevList) =>
        prevList.map((post) =>
          post?.postInfo?.postId === postIdToSync
            ? mergePostData(post, latestPostData)
            : post
        )
      );
    } catch (error) {
      console.error("Failed to sync post data after modal close:", error);
    }
  }, [language, restrictedViewerToken, restrictedViewerTokens, mergePostData]);

  const openModal = (mediaFiles, initialSlide) => {
    console.log("Opening modal with:", mediaFiles, initialSlide);

    // setIsLoading(true);
    setSliderSettings((prevSettings) => ({
      ...prevSettings,
      initialSlide: initialSlide,
    }));
    setMediaFiles(mediaFiles);
    setIsModalOpen(true);
  };

  const closeModal = (closePayload = singlepostId) => {
    const isPayloadObject =
      typeof closePayload === "object" && closePayload !== null;

    const postIdToSync = isPayloadObject
      ? closePayload?.postId ?? singlepostId
      : closePayload;

    const modalPostSnapshot = isPayloadObject
      ? closePayload?.postSnapshot
      : null;

    const modalCommentsSnapshot = isPayloadObject
      ? closePayload?.commentsSnapshot
      : null;

    setIsModalOpen(false);
    setIspostmodalOpen(false);

    if (postIdToSync && modalPostSnapshot) {
      setPostList((prevList) =>
        prevList.map((post) =>
          post?.postInfo?.postId === postIdToSync
            ? mergePostData(post, modalPostSnapshot, modalCommentsSnapshot)
            : post
        )
      );
    }

    setTimeout(() => {
      syncPostInFeed(postIdToSync);
    }, 350);
  };

  const [isfollowed, setIsfollowed] = useState();
  const [isfollowedComp, setIsfollowedComp] = useState();
  const [isConnected, setIsConnected] = useState();

  const [emojiList, setemojiList] = useState();

  const GetEmoji = useCallback(async () => {
    // Return cached emoji if available
    if (cachedEmojiRef.current) {
      setemojiList(cachedEmojiRef.current);
      return;
    }

    try {
      const responseData = await getEmojiDDL(language);

      cachedEmojiRef.current = responseData;
      setemojiList(responseData);
    } catch (error) {
      console.error('Error fetching emoji:', error);
    }
  }, [language]);
  useEffect(() => {
    GetEmoji();
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [postLikedType, setPostLikedType] = useState(false);
  const [postId, setPostId] = useState("");
  const [initialSlideIndex, setInitialSlideIndex] = useState(0);
  const [imageArray, setImageArray] = useState([]);

  const handleShowModal = (item) => {
    setPostId(item?.postInfo?.postId);
    setPostLikedType(item?.postInfo?.postActionsInfo?.likedType);
    setShowModal(true);
  };
  const handleLikesCloseModal = () => {
    setShowModal(false);
    setPostIdLikeData([])
  };

  const handleProfileImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = people.DefaultProfile;
  };

  const handlePostMediaImageError = (e) => {
    if (!e || !e.target) return;
    e.target.onerror = null;
    e.target.src = post.noimgavailable;
  };

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    scrollToTop();
  }, []);

  const [showDeletePost, setShowDeletePost] = useState(false);


  const [userPer, setUserPer] = useState();
  const [alert, setAlert] = useState(false);
  const [isLoadingalert, setIsLoadingalert] = useState(true);
  const fetchDataRef = useRef(false);
  const userConfigRef = useRef(false);

  const fetchData = useCallback(async () => {
    // Prevent duplicate calls
    if (fetchDataRef.current) return;
    fetchDataRef.current = true;

    try {
      const controller = new AbortController();
      abortControllersRef.current['fetchData'] = controller;

      const Response = await getOwnInfo();
      if (!Response) return;
      setData(Response);

      const hasModalShown = sessionStorage.getItem('hasModalShown');
      if (!hasModalShown && (Response?.dob === null || Response?.genderId === null || Response?.cityID === null)) {
        sessionStorage.setItem('hasModalShown', 'true');
        setShowUserAuthModal(true);
        document.body.classList.add('modal-open');
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error fetching data:', error);
      }
    } finally {
      fetchDataRef.current = false;
    }
  }, [sessionId, language]);

  const getUserProfilePer = useCallback(async () => {
    try {
      const controller = new AbortController();
      abortControllersRef.current['profilePer'] = controller;

      const res = await getProfilePercentage();
      if (!res) return;
      setUserPer(res.percentage);
      localStorage.setItem("ProfilePercentage", res.percentage);
      console.log("userPer", res.percentage);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error fetching profile percentage:', error);
      }
    } finally {
      setIsLoadingalert(false);
    }
  }, [sessionId]);
  console.log("userPer", userPer);

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");

    if (sessionId) {
      (async () => {
        await Promise.all([
          getUserProfilePer()

        ]);
      })();
    }
  }, [sessionId]);

  const normalizedUserPer = Array.isArray(userPer)
    ? userPer.length === 0
      ? 0
      : Number(userPer[0])
    : Number(userPer);

  // Condition to show the alert
  const shouldShowAlert =
    !isLoadingalert &&
    normalizedUserPer <= 59 &&
    alert === false &&
    guestModeData === null;


  const [pr, setPR] = useState([]);
  const [jr, setJR] = useState([]);
  const [cr, setCR] = useState([]);

  const [profileConfig, setProfileConfig] = useState("");

  const userConfig = useCallback(async () => {
    // Prevent duplicate calls
    if (userConfigRef.current) return;
    userConfigRef.current = true;

    try {
      const Response = await getUserConfig();

      setProfileConfig(Response);

      if (Response?.hasDob !== true || Response?.hasGender !== true || Response?.hasCity !== true) {
        await fetchData();
      }
    } catch (error) {
      if ((error.code === "ERR_NETWORK" && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        setUnauthorisedModal(true);
      } else {
        console.error('Error fetching user config:', error);
      }
    } finally {
      userConfigRef.current = false;
    }
  }, [sessionId, language, fetchData]);

  const getPeopleRecommendation = useCallback(async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: 1,
      pageSize: 8,
      loggedInUserEngagedUsersIDs: loggedInUser_EngagedUsersIDs,
      peopleRecommendationsIds: peopleRecommendationsIds,
      enableAlgo: enableAlgoKey,
    };

    try {
      const controller = new AbortController();
      abortControllersRef.current['peopleRec'] = controller;

      const response = await axios.post(`Feature/PeopleRecommendations`, data, {
        signal: controller.signal
      });

      const res = response.data.responseData;
      setPR(res.dataList);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error fetching people recommendations:', error);
      }
    } finally {
      setIsLoadingalert(false);
    }
  }, [loggedInUser_EngagedUsersIDs, peopleRecommendationsIds, sessionId]);

  const getJobRecommendation = useCallback(async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: 1,
      pageSize: 8,
      jobRecommendationsIds: jobRecommendationsIds,
      enableAlgo: enableAlgoKey,
    };

    try {
      const controller = new AbortController();
      abortControllersRef.current['jobRec'] = controller;

      const response = await axios.post(`/Feature/JobRecommendations`, data, {
        signal: controller.signal
      });

      const res = response.data.responseData;
      setJR(res.dataList);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error fetching job recommendations:', error);
      }
    } finally {
      setIsLoadingalert(false);
    }
  }, [sessionId, jobRecommendationsIds]);

    const cleanShortDescription = (htmlString) => {
    return htmlString
      ?.replace(/<h3>/gi, "<div>")
      ?.replace(/<\/h3>/gi, "</div>")
      ?.replace(/<strong>/gi, "")
      ?.replace(/<\/strong>/gi, "");
  };

  const getCompanyRecommendation = useCallback(async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      pageNumber: 1,
      pageSize: 8,
      companyRecommendationsIds: companyRecommendationsIds,
      enableAlgo: enableAlgoKey,
    };

    try {
      const controller = new AbortController();
      abortControllersRef.current['companyRec'] = controller;

      const response = await axios.post(`/Feature/CompanyRecommendations`, data, {
        signal: controller.signal
      });

      const res = response.data.responseData;
      setCR(res.dataList);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error fetching company recommendations:', error);
      }
    } finally {
      setIsLoadingalert(false);
    }
  }, [sessionId, companyRecommendationsIds]);

  const scrollRef = useRef(null);

  // const scroll = (direction) => {
  //   if (scrollRef.current) {
  //     const scrollAmount = 300; // Adjust scroll distance as needed
  //     scrollRef.current.scrollBy({
  //       left: direction === "left" ? -scrollAmount : scrollAmount,
  //       behavior: "smooth",
  //     });
  //   }
  // };

  const scroll = (direction) => {
    const el = scrollRef.current;
    if (!el) return;

    const scrollAmount = 300;
    const maxScroll = el.scrollWidth - el.clientWidth;

    if (direction === "left" && el.scrollLeft <= 0) return;
    if (direction === "right" && el.scrollLeft >= maxScroll) return;

    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const scrollRef1 = useRef(null);

  const scroll1 = (direction) => {
    const el = scrollRef1.current;
    if (!el) return;

    const scrollAmount = 300;
    const maxScroll = el.scrollWidth - el.clientWidth;

    if (direction === "left" && el.scrollLeft <= 0) return;
    if (direction === "right" && el.scrollLeft >= maxScroll) return;

    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const scrollRef2 = useRef(null);

  const scroll2 = (direction) => {
    const el = scrollRef2.current;
    if (!el) return;

    const scrollAmount = 300;
    const maxScroll = el.scrollWidth - el.clientWidth;

    if (direction === "left" && el.scrollLeft <= 0) return;
    if (direction === "right" && el.scrollLeft >= maxScroll) return;

    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const [recommendationList, setRecommendationList] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggleDropdown = (index) => {
    setShowDropdown((prev) => (prev === index ? null : index));
  };
  const [followedCompanies, setFollowedCompanies] = useState({});
  const [bookmarkModal, setBookmarkModal] = useState(false);
  const [showAppliedModal, setShowAppliedModal] = useState(false);
  // const handleShow = () => setShowAppliedModal(true);
  const handleShow = (jobId) => {
    setSelectedJobId(jobId);
    setShowAppliedModal(true);
  };

  const handleCloseModal = () => setShowAppliedModal(false);
  const closeModalData = () => {
    setBookmarkModal(false);
  };

  // JobId ko Understand kerne ke liye means Track karega
  const [selectedJobId, setSelectedJobId] = useState(null);

  // const [checkApplied, setCheckApplied] = useState(false);

  // ************************ Apply Job ************************ //
  const applyNew = useCallback(async (jobId) => {
    // Optimistic UI update
    setJR((prevList) =>
      prevList.map((item) =>
        item.jobId === jobId
          ? { ...item, jobActionInfo: { ...item.jobActionInfo, isApplied: true } }
          : item
      )
    );

    try {
      const controller = new AbortController();
      abortControllersRef.current[`applyJob_${jobId}`] = controller;

      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        jobId: jobId,
        type: 1,
        userUid: userUid,
        langKey: language === "en" ? "" : language,
      };

      const res = await axios.post("/JobAction/ApplyJob", body, {
        signal: controller.signal
      });

      setToastMessage(res.data.message);
      setShowToast(true);
    } catch (error) {
      // Rollback on error
      setJR((prevList) =>
        prevList.map((item) =>
          item.jobId === jobId
            ? { ...item, jobActionInfo: { ...item.jobActionInfo, isApplied: false } }
            : item
        )
      );

      if (error.name !== 'AbortError') {
        if (error.response && (error.response.status === 404 || error.response.status === 400)) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response?.data?.message || "Error applying to job");
          setShowErrorToast(true);
        }
      }
    }
  }, [sessionId, userUid, language]);

  // ************************ Unapply Job ************************ //
  const unapplyNew = useCallback(async (jobId) => {
    // Optimistic UI update
    setJR((prevList) =>
      prevList.map((item) =>
        item.jobId === jobId
          ? { ...item, jobActionInfo: { ...item.jobActionInfo, isApplied: false } }
          : item
      )
    );

    try {
      const controller = new AbortController();
      abortControllersRef.current[`unapplyJob_${jobId}`] = controller;

      const body = {
        deviceType: "Web",
        sessionId: sessionId,
        jobId: jobId,
        type: 1,
        userUid: userUid,
        langKey: language === "en" ? "" : language,
      };

      const res = await axios.post("/JobAction/UnApplyJob", body, {
        signal: controller.signal
      });

      setToastMessage(res.data.message);
      setShowToast(true);
      handleCloseModal();
    } catch (error) {
      // Rollback on error
      setJR((prevList) =>
        prevList.map((item) =>
          item.jobId === jobId
            ? { ...item, jobActionInfo: { ...item.jobActionInfo, isApplied: true } }
            : item
        )
      );

      if (error.name !== 'AbortError') {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response?.data?.message || "Error unapplying from job");
          setShowErrorToast(true);
        }
      }
    }
  }, [sessionId, userUid, language]);

  const [showResumeModal, setShowResumeModal] = useState(false);
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);




  //************************Save job End  ************************//
  // const [savedJobs, setSavedJobs] = useState(new Set()); 

  // ************************ Save job ************************ //
  // const saveJob = async (jobId) => {
  //   // Optimistic UI update
  //   // setSavedJobs((prev) => new Set(prev).add(jobId));

  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     jobId: jobId,
  //   };

  //   try {
  //     await axios.post(`JobAction/SaveJob`, responseData).then((res) => {
  //       console.log("save post", res);
  //       setToastMessage(res.data.message);
  //       setShowToast(true);
  //       setJR((prevList) =>
  //       prevList.map((item) =>
  //         item.jobId === jobId
  //           ? { ...item, isConnectedByYou: false }
  //           : item
  //       )
  //     );
  //       // getJobRecommendation();
  //     });
  //   } catch (e) {


  //     if (e.response && e.response.status === 404) {
  //       setWarningToastMessage(e.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(e.response?.data?.message || "Something went wrong");
  //       setShowErrorToast(true);
  //     }
  //   }
  // };

  // // ************************ UnSave job ************************ //
  // const unsaveJob = async (jobId) => {
  //   // Optimistic UI update
  //   setSavedJobs((prev) => {
  //     const newSavedJobs = new Set(prev);
  //     newSavedJobs.delete(jobId);
  //     return newSavedJobs;
  //   });

  //   const responseData = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //     jobId: jobId,
  //   };

  //   try {
  //     await axios.post(`JobAction/UnSaveJob`, responseData).then((res) => {
  //       console.log("unsave post", res);
  //       setToastMessage(res.data.message);
  //       setShowToast(true);
  //       // getJobRecommendation();

  //     });
  //   } catch (e) {
  //     // Rollback if API fails
  //     // setSavedJobs((prev) => new Set(prev).add(jobId));

  //     if (e.response && e.response.status === 404) {
  //       setWarningToastMessage(e.response.data.message);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(e.response?.data?.message || "Something went wrong");
  //       setShowErrorToast(true);
  //     }
  //   }
  // };

  // ************************ Save Job ************************ //
  const saveJob = useCallback(async (jobId) => {
    // Optimistic UI update
    setJR((prevList) =>
      prevList.map((item) =>
        item.jobId === jobId
          ? { ...item, jobActionInfo: { ...item.jobActionInfo, isSaved: true } }
          : item
      )
    );

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };

    try {
      const controller = new AbortController();
      abortControllersRef.current[`saveJob_${jobId}`] = controller;

      const res = await axios.post(`JobAction/SaveJob`, responseData, {
        signal: controller.signal
      });

      setToastMessage(res.data.message);
      setShowToast(true);
    } catch (error) {
      // Rollback if API fails
      setJR((prevList) =>
        prevList.map((item) =>
          item.jobId === jobId
            ? { ...item, jobActionInfo: { ...item.jobActionInfo, isSaved: false } }
            : item
        )
      );

      if (error.name !== 'AbortError') {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response?.data?.message || "Error saving job");
          setShowErrorToast(true);
        }
      }
    }
  }, [sessionId, language]);

  // ************************ Unsave Job ************************ //
  const unsaveJob = useCallback(async (jobId) => {
    // Optimistic UI update
    setJR((prevList) =>
      prevList.map((item) =>
        item.jobId === jobId
          ? { ...item, jobActionInfo: { ...item.jobActionInfo, isSaved: false } }
          : item
      )
    );

    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };

    try {
      const controller = new AbortController();
      abortControllersRef.current[`unsaveJob_${jobId}`] = controller;

      const res = await axios.post(`JobAction/UnSaveJob`, responseData, {
        signal: controller.signal
      });

      setToastMessage(res.data.message);
      setShowToast(true);
    } catch (error) {
      // Rollback if API fails
      setJR((prevList) =>
        prevList.map((item) =>
          item.jobId === jobId
            ? { ...item, jobActionInfo: { ...item.jobActionInfo, isSaved: true } }
            : item
        )
      );

      if (error.name !== 'AbortError') {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response?.data?.message || "Error unsaving job");
          setShowErrorToast(true);
        }
      }
    }
  }, [sessionId, language]);


  useEffect(() => {
    let scrollY = 0;

    if (isModalOpen) {
      // Save current scroll position
      scrollY = window.scrollY;
      document.body.dataset.scrollY = scrollY; // store in dataset

      // Lock scrolling
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open');
    } else {
      // Unlock scrolling
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open');

      // Restore scroll position
      const storedY = document.body.dataset.scrollY || "0";
      window.scrollTo(0, parseInt(storedY, 10));
    }
  }, [isModalOpen]);

  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.welinkjobs.com/NewsFeed"
        />
      </Helmet>
      <div className="row mt-lg-3">
        <div className="col-md-8 newsfeedPosts">
          {shouldShowAlert && (
            <div className="p-3 closeAccount m-0 mb-3 mt-1">
              <div className="d-flex mb-3 align-items-center">
                <InfoSharpIcon />
                <span className="cardHeader ms-1">
                  {/* Announcement! */}
                  {t("Newsfeed.Announcement")}
                </span>
                <span className="ms-auto">
                  <CloseSharpIcon
                    style={{ width: "20px" }}
                    className="pointer"
                    onClick={() => setAlert(true)} // Dismiss the alert
                  />
                </span>
              </div>
              <div>
                <span>{t("Newsfeed.Accounce")}
                  {/* Please complete your profile up to 60% and must have a valid
                  resume to apply for a job. */}
                </span>
                <Link to={`/User/${userUid}`} className="border-bottom f-600 warn-resume">
                  {t("Newsfeed.Manage Profile")}
                  {/* Manage Profile  */}
                </Link>
              </div>
            </div>
          )}
          <AddPost
          // currentSortType={currentSortType}
            setIsVideoProcessing={setIsVideoProcessing}
            setProgress={setProgress}
            AllPostList={AllPostList}
            PostOriginType={"User"}
            postOriginId={userUid}
            setPostList={setPostList}
            setIsLiked={setIsLiked}
            isLiked={isLiked}
            restrictedViewerToken={restrictedViewerToken}
          />
          {isLoading ? (
            <PostFeedSkeleton count={2} />
          ) : isError ? (
            <div className="mt-2 error-image-cont">
              <img src={post.errorSmall} alt="404 Not Found" />
            </div>
          ) : (
            <>
              {postsWithAds
                ?.filter((item) => !item.isHidden)
                .map((item, index) => {

                  const now = moment.utc().local();
                  const itemTime = moment.utc(item?.postInfo?.creationTime).local();
                  const diffSeconds = now.diff(itemTime, "seconds");
                  const diffMinutes = now.diff(itemTime, "minutes");
                  const diffHours = now.diff(itemTime, "hours");
                  const diffDays = now.diff(itemTime, "days");

                  const diffMonths = now.diff(itemTime, "months", true);
                  const diffYears = now.diff(itemTime, "years", true);

                  let result = "";

                  /* JUST NOW */
                  if (diffSeconds < 60) {
                    result = t("Notifications.Just Now");
                  }

                  /* MINUTES */
                  else if (diffMinutes < 60) {
                    result =
                      diffMinutes === 1
                        ? `${diffMinutes} ${t("Notifications.Minute")} ${t("Notifications.Ago")}`
                        : `${diffMinutes} ${t("Notifications.Minutes")} ${t("Notifications.Ago")}`;
                  }

                  /* HOURS */
                  else if (diffHours < 24) {
                    result =
                      diffHours === 1
                        ? `${diffHours} ${t("Notifications.Hour")} ${t("Notifications.Ago")}`
                        : `${diffHours} ${t("Notifications.Hours")} ${t("Notifications.Ago")}`;
                  }

                  /* DAYS */
                  else if (diffDays < 30) {
                    result =
                      diffDays === 1
                        ? `${diffDays} ${t("Notifications.Day")} ${t("Notifications.Ago")}`
                        : `${diffDays} ${t("Notifications.Days")} ${t("Notifications.Ago")}`;
                  }

                  /* MONTHS */
                  else if (diffMonths < 12) {
                    const displayMonth =
                      diffMonths >= 0.75 && diffMonths < 1.25
                        ? 1
                        : Math.round(diffMonths * 2) / 2;

                    result =
                      displayMonth === 1
                        ? `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Month")} ${t("Notifications.Ago")}`
                        : `${t("Notifications.PostedAround")} ${displayMonth} ${t("Notifications.Months")} ${t("Notifications.Ago")}`;
                  }

                  /* YEARS */
                  else {
                    const displayYear =
                      diffYears >= 0.75 && diffYears < 1.25
                        ? 1
                        : Math.round(diffYears * 2) / 2;

                    result =
                      displayYear === 1
                        ? `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Year")} ${t("Notifications.Ago")}`
                        : `${t("Notifications.PostedAround")} ${displayYear} ${t("Notifications.Years")} ${t("Notifications.Ago")}`;
                  }



                  const feedItemKey = item.isAd
                    ? `ad-${index}`
                    : item.isPeopleRecommendation
                      ? `people-rec-${index}`
                      : item.isJobRecommendation
                        ? `job-rec-${index}`
                        : item.isCompanyRecommendation
                          ? `company-rec-${index}`
                          : `post-${item?.postInfo?.postId ?? index}`;

                  return (
                    <React.Fragment key={feedItemKey}>
                      {item.isAd && (
                        <Advertisement key={`ad-${index}`} />
                      )}
                      {(peopleRecommendationsIds && peopleRecommendationsIds !== "null" && peopleRecommendationsIds.trim() !== "") &&
                        (loggedInUser_EngagedUsersIDs && loggedInUser_EngagedUsersIDs !== "null" && loggedInUser_EngagedUsersIDs.trim() !== "") && (
                          <>
                            <div ref={sectionRef} >

                              {item.isPeopleRecommendation && pr?.length > 0 ? (
                                <div className="pr-container" >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <h5>{t("Newsfeed.People Recommendation")}</h5>
                                    <div className="d-flex align-items-center gap-2">
                                      <a href="/Connections#Recommendations" className="f-12" target="_blank">{t("Newsfeed.Show More")}</a>
                                      <ArrowForwardSharpIcon className="material-symbols-sharp me-0" />
                                    </div>
                                  </div>
                                  <div className="pr-wrapper">
                                    {pr?.length > 1 && (
                                    <button
                                      className="scroll-btn left"
                                      style={{ left: '5px', padding: '18px 20px 18px 18px', backgroundColor: 'gainsboro' }}
                                      onClick={() => scroll("left")}
                                    >
                                      <ArrowLeftSharpIcon size={40} style={{ fontSize: '45px' }} />
                                    </button>
                                    )}
                                    <div className="pr-scroll" ref={scrollRef}>
                                      {pr?.map((prItem) => (
                                        <div className="pr-card justify-content-between" key={prItem.userUid}>
                                          <div className="mb-1">
                                            <NavLink to={`/User/${prItem.userUid}`} key={index} target="_blank">

                                              <img
                                                src={prItem.profilPic}
                                                alt={prItem.fullName}
                                                className="pr-avatar"
                                                onError={handleProfileImageError}
                                              />
                                            </NavLink>
                                            <div className="pr-info mt-4">
                                              <NavLink to={`/User/${prItem.userUid}`} key={index} target="_blank">
                                                <h5>{prItem.fullName}</h5>
                                                <p className="pr-handle">
                                                  {prItem.nameTag}
                                                </p>
                                                <p className="pr-title f-600">{prItem.title}</p>
                                                <p className="pr-headline fst-italic">
                                                  {prItem.headLine}
                                                </p>
                                                {prItem.followersCount >= 5 && (
                                                  <p className="pr-followers">
                                                    {prItem.followersCount} {t("My Connection.Followers")}
                                                  </p>
                                                )}
                                                {prItem.mutualUsers?.count > 0 && (
                                                  <div className="pr-mutual">
                                                    <p>{prItem.mutualUsers.text}</p>
                                                    <div className="mutual-imgs">
                                                      {prItem.mutualUsers?.pics?.map(
                                                        (pic, idx) => (
                                                          <img
                                                            key={idx}
                                                            src={pic}
                                                            alt="Mutual Connection"
                                                            onError={handleProfileImageError}
                                                          />
                                                        )
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                              </NavLink>
                                            </div>
                                          </div>
                                          <div className="pr-action">
                                            <RecommendationAction
                                              item={prItem}
                                              GetRecommendation={
                                                getPeopleRecommendation
                                              }
                                              setPR={setPR}
                                              setRecommendationList={
                                                setRecommendationList
                                              }
                                              handleToggleDropdown={
                                                handleToggleDropdown
                                              }
                                              index={index}
                                              setShowDropdown={setShowDropdown}
                                              showDropdown={showDropdown}
                                            />
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                    {pr?.length > 1 && (
                                    <button
                                      className="scroll-btn right"
                                      style={{ right: '5px', padding: '18px 18px 18px 20px', backgroundColor: 'gainsboro' }}
                                      onClick={() => scroll("right")}
                                    >
                                      <ArrowRightSharpIcon size={40} style={{ fontSize: '45px' }} />
                                    </button>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                // <> {item.isAd && <Advertisement key={`ad-${index}`} />}</>
                                null
                              )}
                            </div>
                          </>
                        )}

                      {(jobRecommendationsIds && jobRecommendationsIds !== "null" && jobRecommendationsIds.trim() !== "") && (
                        <>  {item.isJobRecommendation && jr?.length > 0 ? (
                          <div className="pr-container" >
                            <div className="d-flex justify-content-between align-items-center ">
                              <h5>{t("Newsfeed.Job Recommendation")}</h5>
                              <div className="d-flex align-items-center gap-2">
                                <a href="/SearchJob" className="f-12 " target="_blank">{t("Newsfeed.Show More")}
                                </a>
                                <ArrowForwardSharpIcon className="material-symbols-sharp me-0" />

                              </div>
                            </div>

                            <div className="pr-wrapper">
                              {jr?.length > 1 && (
                              <button
                                className="scroll-btn left"
                                style={{ left: '5px', padding: '18px 20px 18px 18px', backgroundColor: 'gainsboro' }}
                                onClick={() => scroll1("left")}
                              >
                                <ArrowLeftSharpIcon size={40} style={{ fontSize: '45px' }} />
                              </button>
                              )}
                              <div className="pr-scroll" ref={scrollRef1}>
                                {jr?.map((prItem) => (
                                  <div className="pr-card justify-content-between" key={prItem.jobId}>
                                    <div className="mb-1">
                                      <NavLink to={`/JobDetail/${prItem.jobId}`} key={index} target="_blank">
                                        <img
                                          src={prItem.compLogo}
                                          alt={prItem.compName}
                                          className="pr-avatar"
                                          onError={handleProfileImageError}
                                        />
                                      </NavLink>
                                      <div className="pr-info">
                                        <NavLink to={`/JobDetail/${prItem.jobId}`} key={index} target="_blank">

                                          <h5>{prItem.compName}</h5>
                                          <p className="pr-handle">{prItem.cityName}</p>
                                          <p className="pr-title f-600">{prItem.title}</p>
                                          <div 
                                           className="pr-headline overviewDescription fst-italic"
                                                dangerouslySetInnerHTML={{
                                                  __html: cleanShortDescription(
                                                    prItem.shortDescription
                                                  ),
                                                }} />
                                            {/* {prItem.shortDescription} */}
                                              
                                          {/* </div> */}
                                          
                                          {prItem.jobAppliedCount >= 5 ? (

                                            <p className="pr-followers">
                                              {prItem.jobAppliedCount} {t("Newsfeed.Applicants")}
                                            </p>
                                          ) : ""}
                                          {prItem.applicantsInfo?.count > 0 && (
                                            <div className="pr-mutual">
                                              <p>{prItem.applicantsInfo.text}</p>
                                              <div className="mutual-imgs">
                                                {prItem.applicantsInfo?.pics?.map(
                                                  (pic, idx) => (
                                                    <img
                                                      key={idx}
                                                      src={pic}
                                                      alt={`Applicant ${idx + 1}`}
                                                      onError={handleProfileImageError}
                                                    />
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </NavLink>
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-center align-items-center">
                                      {/* {prItem?.jobActionInfo?.isApplied === true || checkApplied === true ? ( */}
                                      {prItem?.jobActionInfo?.isApplied === true ? (
                                        <button
                                          className="wljSecondaryBtn  appliedBtn mt-4"
                                          style={{ padding: "5px", fontSize: "12px" }}
                                          onClick={() => {
                                            guestModeData === "true"
                                              ? setBookmarkModal(true)
                                              : handleShow(prItem?.jobId);
                                            // setIsappliedF(false);
                                          }} >
                                          <span className="default-text applyB">
                                            {t("Manage Job.Applied")}
                                          </span>
                                          <span className="hover-text applyB">
                                            {t("Manage Job.Unapply")}
                                          </span>
                                        </button>
                                      ) : (
                                        <button
                                          className="mainBtn mt-4"
                                          style={{ padding: "5px", fontSize: "12px" }}
                                          onClick={() =>
                                            guestModeData === "true"
                                              ? setBookmarkModal(true)
                                              : ((profileConfig.hasCcv === null || profileConfig.hasCcv === false) ||
                                                userPer?.percentage < 60)
                                                ? setShowResumeModal(!showResumeModal)
                                                : applyNew(prItem?.jobId)
                                          }
                                        >
                                          {t("SearchJob.Apply Now")}
                                        </button>
                                      )}
                                      {
                                        prItem?.jobActionInfo?.isSaved === true ? (
                                          <div className="d-flex align-items-center postAction mt-4 ms-2">
                                            <button
                                              className="wljSecondaryBtn  appliedBtn"
                                              style={{ padding: "5px", fontSize: "12px" }}
                                              onClick={() => {
                                                if (guestModeData !== "true") {
                                                  unsaveJob(prItem?.jobId);
                                                }
                                              }}
                                            >

                                              {t("Connections.Unsave")}

                                            </button>
                                          </div>
                                        ) : (
                                          <div className="d-flex align-items-center postAction mt-4 ms-2">
                                            <button
                                              className="mainBtn  appliedBtn"
                                              style={{ padding: "5px", fontSize: "12px" }}
                                              onClick={() => {
                                                if (guestModeData !== "true") {
                                                  saveJob(prItem?.jobId);
                                                }
                                              }}
                                            >
                                              {t("Connections.Save")}

                                            </button>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                              {jr?.length > 1 && (
                              <button
                                className="scroll-btn right"
                                style={{ right: '5px', padding: '18px 18px 18px 20px', backgroundColor: 'gainsboro' }}
                                onClick={() => scroll1("right")}
                              >
                                <ArrowRightSharpIcon size={40} style={{ fontSize: '45px' }} />
                              </button>
                              )}
                            </div>
                          </div>
                        ) : (
                          null
                          // <> {item.isAd && <Advertisement key={`ad-${index}`} />}</>
                        )}
                        </>
                      )}

                      {(companyRecommendationsIds && companyRecommendationsIds !== "null" && companyRecommendationsIds.trim() !== "") && (
                        <>
                          {item.isCompanyRecommendation && cr?.length > 0 ? (
                            <div className="pr-container" >
                              <div className="pr-wrapper">
                                <div className="d-flex justify-content-between align-items-center ">

                                  <h5>{t("Newsfeed.Company Recommendation")}</h5>
                                  <div className="d-flex align-items-center gap-2">
                                    <a href="/Connections#Recommendations" className="f-12 " target="_blank">{t("Newsfeed.Show More")}</a>
                                    <ArrowForwardSharpIcon className="material-symbols-sharp me-0" />
                                  </div>
                                </div>
                                {cr?.length > 1 && (
                                <button
                                  className="scroll-btn left"
                                  style={{ left: '5px', padding: '18px 20px 18px 18px', backgroundColor: 'gainsboro' }}
                                  onClick={() => scroll2("left")}
                                >
                                  <ArrowLeftSharpIcon size={40} style={{ fontSize: '45px' }} />
                                </button>
                                )}
                                <div className="pr-scroll" ref={scrollRef2}>
                                  {cr?.map((prItem) => (
                                    <div className="pr-card justify-content-between" key={prItem.companyUid}>
                                      <div className="mb-1">
                                        <NavLink to={`/Company/${prItem.companyUid}/${prItem.companyName}`} key={index} target="_blank">
                                          <img
                                            src={prItem.companyLogo}
                                            alt={prItem.companyName}
                                            className="pr-avatar"
                                            onError={handleProfileImageError}
                                          />
                                        </NavLink>
                                        <div className="pr-info mt-2">
                                          <NavLink to={`/Company/${prItem.companyUid}/${prItem.companyName}`} key={index} target="_blank">
                                            <h5>{prItem.companyName}</h5>
                                            <p className="pr-handle">{prItem.city}</p>
                                            <p className="pr-title f-600">{prItem.title}</p>
                                            {prItem.followersCount >= 5 && (
                                              <p className="pr-followers">
                                                {prItem.followersCount} {t("My Connection.Followers")}
                                              </p>
                                            )}
                                            {prItem.networkFollowers?.count > 0 && (
                                              <div className="pr-mutual">
                                                <p>{prItem.networkFollowers.text}</p>
                                                <div className="mutual-imgs">
                                                  {prItem.networkFollowers?.pics?.map(
                                                    (pic, idx) => (
                                                      <img
                                                        key={idx}
                                                        src={pic}
                                                        alt={`Connection ${idx + 1}`}
                                                        onError={handleProfileImageError}
                                                      />
                                                    )
                                                  )}
                                                </div>
                                              </div>
                                            )}
                                          </NavLink>
                                        </div>
                                      </div>
                                      <CompanyInteraction
                                        item={prItem}
                                        isCompanyFollowed={prItem.isFollowedByYou}
                                        index={index}
                                        followedCompanies={followedCompanies}
                                        setFollowedCompanies={setFollowedCompanies}
                                        getCompanyList={getCompanyRecommendation}
                                      />
                                    </div>
                                  ))}
                                </div>
                                {cr?.length > 1 && (
                                <button
                                  className="scroll-btn right"
                                  style={{ right: '5px', padding: '18px 18px 18px 20px', backgroundColor: 'gainsboro' }}
                                  onClick={() => scroll2("right")}
                                >
                                  <ArrowRightSharpIcon size={40} style={{ fontSize: '45px' }} />
                                </button>
                                )}
                              </div>
                            </div>
                          ) : (
                            null
                            // <> {item.isAd && <Advertisement key={`ad-${index}`} />}</>
                          )}
                        </>
                      )}


                      {!item.isAd &&
                        !item.isPeopleRecommendation &&
                        !item.isJobRecommendation &&
                        !item.isCompanyRecommendation && (
                          <div
                            className="featured-card user-postOnlyContent p-2 mb-3"
                          >
                            {guestModeData === "true" ? (
                              ""
                            ) : (
                              <>
                                {item?.isSuggested === true && (
                                  <div

                                    className={`postData d-flex align-items-center border-custom1 `}
                                    style={{
                                      direction: language === "ar" ? "rtl" : "ltr",
                                      textAlign: language === "ar" ? "right" : "left"
                                    }}
                                  >
                                    <div className="thumb" style={{
                                      marginLeft: language === "ar" ? "10px" : "initial",
                                    }}>
                                      <ThumbUpSharpIcon />
                                    </div>
                                    <div className="ms-2"  >
                                      <p className=" gradient-text">
                                        {t("Newsfeed.Suggested based on your network")}
                                        {/* Suggested based on your network */}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}

                            {item?.contentInfo === null ? (
                              ""
                            ) : (
                              <div
                                className={`postData d-flex align-items-center border-custom1 `}
                                style={{
                                  direction: language === "ar" ? "rtl" : "ltr",
                                  textAlign: language === "ar" ? "right" : "left",
                                }}
                              >
                                <div className="circle-container" style={{
                                  marginLeft: language === "ar" ? "10px" : "initial",
                                }}
                                >
                                  {item?.contentInfo?.pics?.map((pic, idx) => (
                                    <>
                                      <img
                                        src={pic}
                                        alt={`Circle ${idx + 1}`}
                                        className="circle-img borderCircle"
                                        key={idx}
                                        onError={handleProfileImageError}
                                      />
                                    </>
                                  ))}
                                </div>
                                <div
                                  style={{

                                    marginLeft:
                                      item?.contentInfo?.count === 3
                                        ? "3px"
                                        : "10px",
                                  }}
                                >
                                  <p className="f-12" >
                                    {item?.contentInfo?.text} {language === "ar" ? (
                                      item?.contentInfo?.count > 3 ?
                                        (` ${t("SignIn.And")} ${item?.contentInfo?.count - 2} ${item?.contentInfo?.contentInfoType
                                          // > 15 ? item?.contentInfo?.contentInfoType.slice(0, 15) + "..." : item?.contentInfo?.contentInfoType
                                          }`) :
                                        (`${item?.contentInfo?.contentInfoType
                                          //  > 15 ? item?.contentInfo?.contentInfoType.slice(0, 15) + "..." : item?.contentInfo?.contentInfoType 
                                          }`)


                                    ) : (
                                      item?.contentInfo?.count > 3 ?
                                        (`${t("SignIn.And")} ${item?.contentInfo?.count - 2} ${t("SignIn.others")} 
                                    ${item?.contentInfo?.contentInfoType
                                          // > 15 ? item?.contentInfo?.contentInfoType.slice(0, 15) + "..." : item?.contentInfo?.contentInfoType
                                          }`) :
                                        (`${item?.contentInfo?.contentInfoType
                                          //  > 15 ? item?.contentInfo?.contentInfoType.slice(0, 15) + "..." : item?.contentInfo?.contentInfoType 
                                          }`)


                                    )}

                                  </p>
                                </div>
                              </div>
                            )}

                            <div className="feature-content p-md-2 d-flex justify-content-between mb-0 RemovePaddingMobile">
                              <Link
                                className="mb-1"
                                to={
                                  item?.postInfo?.postOriginType === "Company"
                                    ? `/Company/${item?.postInfo?.userUid}/${item?.postInfo?.userName}`
                                    : `/User/${item?.postInfo?.userUid}`
                                }
                              >
                                <div className="d-flex">
                                  <div className="ImgAvatar">
                                    <img
                                      src={item?.postInfo?.userAvatar || people.DefaultProfile}
                                      alt=""
                                      style={{ borderRadius: "50px" }}
                                      onError={handleProfileImageError}
                                    />
                                  </div>

                                  <div className="ms-2 mb-2">
                                    <div className="d-flex userName">
                                      <h4 className="f-14 fw-bold mb-0 ">
                                        {item?.postInfo?.userName}{" "}
                                        <span className="f-12 ms- fw-600" style={{ color: 'rgb(58, 116, 246)' }}>{item?.postInfo?.nameTag}</span>
                                      </h4>
                                    </div>
                                    <p className="f-12">
                                      {item?.postInfo?.title}
                                    </p>
                                    <p className="f-12">
                                      {item?.postInfo?.additionalInfo}
                                    </p>
                                    <div className="d-flex justify-content-start align-items-center">
                                      <div>
                                        {language === "ar" ? (
                                          <Tooltip title={moment
                                            .utc(item?.postInfo?.creationTime)
                                            .locale(locale)
                                            .local()
                                            .format("D MMMM YYYY [الساعة] h:mm a")} arrow>
                                            <p className="f-10 label">
                                              {moment
                                                .utc(item?.postInfo?.creationTime)
                                                .locale(locale)
                                                .local()
                                                .format("D MMMM YYYY [الساعة] h:mm a")}
                                            </p>
                                          </Tooltip>
                                        ) : (
                                          <Tooltip title={moment
                                            .utc(item?.postInfo?.creationTime)
                                            .local()
                                            .format(language === "en"
                                              ? "D MMMM YYYY [at] h:mm a"
                                              : "D MMMM YYYY [को] h:mm a")} arrow>
                                            <p className="f-10 label">
                                              {result}
                                              {/* {moment(item?.postInfo?.creationTime).fromNow()}  */}
                                            </p>
                                          </Tooltip>


                                        )}
                                      </div>
                                      <div className="ms-1 d-flex align-items-center" >
                                        {item?.postInfo?.privacyType === "Public" && (
                                          <>
                                            <span className="f-800 me-1">·</span><PublicSharpIcon fontSize="inherit" className="f-6 label" style={{ color: '#9e9e9e' }} />
                                          </>
                                        )}
                                        {item?.postInfo?.privacyType === "Friends" && (
                                          <>
                                            <span className="f-800 me-1">·</span><GroupSharpIcon fontSize="small" className=" f-10 label" style={{ color: '#9e9e9e' }} />
                                          </>
                                        )}
                                        {item?.postInfo?.privacyType === "OnlyMe" && (
                                          <>
                                            <span className="f-800 me-1">·</span><LockSharpIcon className="f-10 label" style={{ color: '#9e9e9e' }} />
                                          </>
                                        )}
                                        {item?.postInfo?.privacyType === "Custom" && (
                                          <>
                                            <span className="f-800 me-1">·</span><TuneSharpIcon className="f-10 label" style={{ color: '#9e9e9e' }} />
                                          </>
                                        )}
                                      </div>

                                      <div className=" d-flex align-items-center" >
                                        {item?.postInfo?.deviceType === "Android" && (
                                          <>
                                            <h6 className="f-10  me-1 mb-0 ">
                                              <span className="f-800">·</span> {t("Newsfeed.via")}
                                            </h6>
                                            <Tooltip title="Android" arrow>
                                              <AndroidIcon fontSize="inherit" className="f-6 label" style={{ color: '#9e9e9e' }} />
                                            </Tooltip>
                                          </>
                                        )}
                                        {item?.postInfo?.deviceType === "Web" && (
                                          <>
                                            <h6 className="f-10  me-1 mb-0 ">
                                              <span className="f-800">·</span> {t("Newsfeed.via")}

                                            </h6>
                                            <Tooltip title="Web" arrow>
                                              <LanguageIcon fontSize="inherit" className=" f-10 label" style={{ color: '#9e9e9e' }} />
                                            </Tooltip>
                                          </>
                                        )}
                                        {item?.postInfo?.deviceType === "Ios" && (
                                          <>
                                            <h6 className="f-10  me-1 mb-0 ">
                                              <span className="f-800">·</span> {t("Newsfeed.via")}
                                            </h6>
                                            <Tooltip title="Ios" arrow>
                                              <AppleIcon fontSize="inherit" className="f-10 label" style={{ color: '#9e9e9e' }} />
                                            </Tooltip>
                                          </>
                                        )}

                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </Link>

                              {guestModeData === "true" ? (
                                ""
                              ) : (
                                <div className="d-flex">
                                  {item.cntntTypCategory === 'SharePost' ?
                                    (
                                      <>
                                        <span class=" me-2">
                                          <p className="badge badge-subtle badge-info1 f-12">
                                            {t("Newsfeed.Shared Post")}
                                          </p>
                                        </span>
                                      </>
                                    ) : item.cntntTypCategory === 'Article' ? (
                                      <>
                                        <span class=" me-2">
                                          <p className="badge badge-subtle badge-info1 f-12">
                                            {t("Newsfeed.Article")}
                                          </p>
                                        </span>
                                      </>
                                    ) : null}

                                  <div>
                                    <PostInteractionModal
                                      postId={item?.postInfo?.postId}
                                      AllPostList={AllPostList}
                                      postList={postList}
                                      setPage={setPage}
                                      setPostList={setPostList}
                                      page={page}
                                      setTotalPages={setTotalPages}
                                      totalPages={totalPages}
                                      item={item}
                                      restrictedViewerToken={restrictedViewerToken}
                                      PostOriginType={"User"}
                                      postOriginId={userUid}
                                      isfollowed={isfollowed}
                                      setIsfollowed={setIsfollowed}
                                      isfollowedComp={isfollowedComp}
                                      setIsfollowedComp={setIsfollowedComp}
                                      setIsConnected={setIsConnected}
                                      isConnected={isConnected}
                                      setShowDeletePost={setShowDeletePost}
                                      showDeletePost={showDeletePost}
                                      ispinned={item?.postInfo?.postActionsInfo?.isPinned}
                                      onBeforePostDelete={(deletedPostId) => {
                                        if (visibleVideoRef?.current?.videoEl) {
                                          try {
                                            visibleVideoRef.current.videoEl.pause();
                                          } catch (e) {}
                                          visibleVideoRef.current = null;
                                        }
                                        setActiveVideoId(null);
                                        if (String(singlepostId) === String(deletedPostId)) {
                                          setIsModalOpen(false);
                                          setIspostmodalOpen(false);
                                        }
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                            {item.cntntTypCategory === 'Article' || item.contentType === 'ArticlePost' ?
                              <h4 className="f-14 fw-bold mb-0">
                                {item?.postInfo?.articleInfo?.title}</h4>
                              :
                              <>
                                <PostComponent
                                  item={item} restrictedViewerToken={restrictedViewerToken} />
                              </>
                            }

                            <div
                              className="feed-post"
                              style={{
                                paddingTop:
                                  item?.postInfo?.postMediaCount === 0
                                    ? "60px"
                                    : "4px",
                              }}
                            >
                              <div className="row">
                                {item?.postInfo?.mediaFilesList?.slice(0, 4)?.map(
                                  (file, idx) => (
                                    (
                                      <div
                                        key={idx}
                                        className={`col-${item?.postInfo.mediaFilesList
                                          .length === 1
                                          ? "12"
                                          : "6"
                                          } ${item?.postInfo.mediaFilesList
                                            .length === 3 && idx === 0
                                            ? "col-12"
                                            : ""
                                          }`}
                                        onClick={() => {
                                          console.log("Clicked item:", item);

                                          setInitialSlideIndex(1);
                                          const mediaList = item?.postInfo?.mediaFilesList || [];

                                          const imageData = mediaList.map((file) => file.mediaName);
                                          setImageArray(mediaList);
                                          setSinglePostContent(item);
                                          setSinglePostId(item?.postInfo?.postId);

                                          if (
                                            // item?.cntntTypCategory !== 'Video' ||
                                            // item?.cntntTypCategory !== 'TextWithVideo'
                                            item?.cntntTypCategory === 'UserStory' ||
                                            item?.cntntTypCategory === 'Text' ||
                                            item?.cntntTypCategory === 'TextWithImage' ||
                                            item?.cntntTypCategory === 'Image'
                                          ) {
                                            console.log("Opening modal with:", imageData, idx);
                                            openModal(imageData, 1);
                                          }

                                          if (
                                            item?.cntntTypCategory === 'Article' ||
                                            item?.contentType === 'ArticlePost'
                                          ) {
                                            window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank');

                                          }
                                        }}

                                        style={{
                                          position: "relative",
                                          cursor: 'pointer',
                                          padding:
                                            item?.postInfo?.mediaFilesList
                                              .length === 3 && idx === 0
                                              ? "0 0 5px 0"
                                              : item?.postInfo?.mediaFilesList
                                                .length === 3 && idx === 1
                                                ? "0 5px 5px 0"
                                                : item?.postInfo?.mediaFilesList
                                                  .length === 4 && idx === 2
                                                  ? "0 5px 0 0"
                                                  : item?.postInfo?.mediaFilesList
                                                    .length === 4 && idx === 0
                                                    ? "0 5px 5px 0"
                                                    : item?.postInfo?.mediaFilesList
                                                      .length === 2 && idx === 0
                                                      ? "0 5px 5px 0"
                                                      : "",
                                        }}
                                      >

                                        {item?.cntntTypCategory !== 'TextWithVideo' &&
                                          item?.cntntTypCategory !== 'Video' ? (
                                          <img
                                            src={file?.mediaName}
                                            alt=""
                                            className="img-fluid m-auto modal-imag"
                                            width={"100%"}
                                            onError={handlePostMediaImageError}
                                            style={{
                                              width: '100%',
                                              height:
                                                item?.postInfo?.mediaFilesList?.length === 1 ? 'auto' : '250px',
                                              maxHeight:
                                                item?.postInfo?.mediaFilesList?.length === 1 ? '500px' : '250px',
                                              objectFit:
                                                item?.postInfo?.mediaFilesList?.length === 1 ? 'contain' : 'cover',
                                            }}
                                          />
                                        ) : null}
                                        {item?.cntntTypCategory === 'TextWithVideo' ||
                                          item?.cntntTypCategory === 'Video' ?
                                          <div className="newsfeed-video"
                                          >
                                            <PostVideoCommon
                                              file={file} item={item}
                                              restrictedViewerToken={restrictedViewerToken}
                                              setActiveVideoId={setActiveVideoId}
                                              activeVideoId={activeVideoId}
                                              AllPostList={AllPostList}
                                              setPostList={setPostList}
                                              visibleVideoRef={visibleVideoRef} />
                                          </div> : null}

                                        {idx === 3 &&
                                          item?.postInfo.postMediaCount > 4 && (
                                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                              +
                                              {item?.postInfo.postMediaCount -
                                                4}
                                            </div>
                                          )}
                                      </div>
                                    )
                                  )
                                )}
                              </div>

                              {guestModeData === "true" ? (
                                ""
                              ) : (
                                <>
                                  {console.log("Content Type:", item)}
                                  {item.cntntTypCategory === 'Article' || item.contentType === 'ArticlePost' ?
                                    <div className="row comment-gradient-article">
                                      <PostComponent item={item}
                                        restrictedViewerToken={restrictedViewerToken} />
                                      <div
                                        className="addComment"
                                        onClick={() => {
                                          setInitialSlideIndex(1);
                                          setImageArray(item?.postInfo?.mediaFilesList);
                                          let imageData =
                                            item?.postInfo?.mediaFilesList?.map(
                                              (file) => file.mediaName
                                            );
                                          // openModal(imageData, 1);
                                          if (
                                            //  item?.cntntTypCategory !== 'Video' ||
                                            //   item?.cntntTypCategory !== 'TextWithVideo'
                                            // item?.cntntTypCategory !== 'Video' &&
                                            item?.cntntTypCategory === 'UserStory' ||
                                            item?.cntntTypCategory === 'TextWithImage' ||
                                            item?.cntntTypCategory === 'Text' ||
                                            item?.cntntTypCategory === 'Image'
                                          ) {
                                            openModal(imageData, 1);
                                            console.log("Opening modal with:", imageData, 1);

                                          }
                                          if (
                                            item?.cntntTypCategory === 'Article' ||
                                            item?.contentType === 'ArticlePost'
                                          ) {
                                            window.open(`/Article/${item?.postInfo?.postId}/${item?.postInfo?.articleInfo?.titleSlug}`, '_blank');
                                          }
                                          setSinglePostContent(item);
                                          setSinglePostId(item?.postInfo?.postId);
                                        }}
                                      >
                                        <div
                                          className="postCommentWrapper"
                                          onClick={(event) =>
                                            event.stopPropagation()
                                          }
                                        >
                                          <PostComment
                                            item={item}
                                            postId={item?.postInfo?.postId}
                                            AllPostList={AllPostList}
                                            postList={postList}
                                            setPage={setPage}
                                            setPostList={setPostList}
                                            page={page}
                                            setTotalPages={setTotalPages}
                                            totalPages={totalPages}
                                            updateCommentCount={updateCommentCount}
                                            ispostmodalOpen={ispostmodalOpen}
                                            setIspostmodalOpen={setIspostmodalOpen}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    : (
                                      <div className="row comment-gradient">
                                        <div
                                          className="addComment"
                                        // onClick={() => {
                                        //   setInitialSlideIndex(1);
                                        //   setImageArray(item?.postInfo?.mediaFilesList );
                                        //   let imageData =
                                        //     item?.postInfo?.mediaFilesList?.map(
                                        //       (file) => file.mediaName
                                        //     );
                                        //   openModal(imageData, 1);
                                        //   setSinglePostContent(item);
                                        //   setSinglePostId(item?.postInfo?.postId);
                                        // }}
                                        >
                                          <div
                                            className="postCommentWrapper"
                                            onClick={(event) =>
                                              event.stopPropagation()
                                            }
                                          >
                                            <PostComment
                                              item={item}
                                              postId={item?.postInfo?.postId}
                                              AllPostList={AllPostList}
                                              postList={postList}
                                              setPage={setPage}
                                              setPostList={setPostList}
                                              page={page}
                                              setTotalPages={setTotalPages}
                                              totalPages={totalPages}
                                              updateCommentCount={updateCommentCount}
                                              ispostmodalOpen={ispostmodalOpen}
                                              setIspostmodalOpen={setIspostmodalOpen}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                    )}

                                </>
                              )}
                            </div>

                            <div
                              className={`postData d-flex align-items-center justify-content-between ${item?.postInfo?.likeCount === 0 &&
                                item?.postInfo?.commentCount === 0 &&
                                item?.postInfo?.shareCount === 0
                                ? ""
                                : "border-custom1"
                                }`}
                              style={{
                                direction: language === "ar" ? "rtl" : "ltr",
                                textAlign: language === "ar" ? "right" : "left",
                              }}

                            >
                              {language === "ar" ? (
                                <div className="d-flex">
                                  {/* <div className="circle-container">
                                  {item?.postInfo?.postReactionContent?.pics?.map(
                                    (pic, idx) => (
                                      <>
                                        <img
                                          src={pic}
                                          alt={`Circle ${idx + 1}`}
                                          className="circle-img borderCircle"
                                          key={idx}
                                        />
                                      </>
                                    )
                                  )}
                                </div> */}
                                  <div className="d-flex"
                                    style={{
                                      marginLeft:
                                        item?.contentInfo?.count === 3
                                          ? "12px"
                                          : "10px",
                                    }}
                                  >
                                    {item?.postInfo?.likeCount === 0 || item?.postInfo?.likeCount === null ? (
                                      ""
                                    ) : (
                                      <>
                                        <p
                                          className="f-10 me-2 ms-2 pointer d-flex like-details"
                                          onClick={() => handleShowModal(item)}
                                        >
                                          {item?.postInfo?.likeCount} <ThumbUpOutlinedIcon style={{ color: "#00419f", fontSize: "13px" }} />
                                          {/* {t("Newsfeed.Like")} */}

                                        </p>
                                        <div className="circle-container">
                                          {item?.postInfo?.postReactionContent?.pics?.map(
                                            (pic, idx) => (
                                              <>
                                                <img
                                                  src={pic}
                                                  alt={`Circle ${idx + 1}`}
                                                  className="circle-img borderCircle"
                                                  key={idx}
                                                  onError={handleProfileImageError}
                                                />
                                              </>
                                            )
                                          )}
                                        </div>
                                        <p className="f-10 me-2 pointer d-flex">
                                          {item?.postInfo?.postReactionContent === null
                                            ? ""
                                            : ` ${item?.postInfo?.postReactionContent?.text}`
                                          } {item?.postInfo?.likeCount > 3 && (
                                            ` ${t("SignIn.And")} ${item?.postInfo?.postReactionContent?.count - 2
                                            } ${item?.postInfo?.postReactionContent?.contentInfoType
                                            }`
                                          )
                                          }

                                        </p>
                                      </>

                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="d-flex align-items-center">
                                  {/* <div className="circle-container">
                                  {item?.postInfo?.postReactionContent?.pics?.map(
                                    (pic, idx) => (
                                      <>
                                        <img
                                          src={pic}
                                          alt={`Circle ${idx + 1}`}
                                          className="circle-img borderCircle"
                                          key={idx}
                                        />
                                      </>
                                    )
                                  )}
                                </div> */}
                                  <div
                                    style={{
                                      marginLeft:
                                        item?.contentInfo?.count === 3
                                          ? "12px"
                                          : "10px",
                                    }}
                                    className="d-flex align-items-center "
                                  >
                                    {item?.postInfo?.likeCount === 0 || item?.postInfo?.likeCount === null ? (
                                      ""
                                    ) : (
                                      <>
                                        <p
                                          className="f-10 me-1 pointer d-flex like-details"
                                          onClick={() => handleShowModal(item)}
                                        >
                                          {item?.postInfo?.likeCount} <ThumbUpOutlinedIcon style={{ color: "#00419f", fontSize: "13px" }} />
                                          {/* {t("Newsfeed.Like")} */}
                                        </p>
                                        <div className="circle-container">
                                          {item?.postInfo?.postReactionContent?.pics?.map(
                                            (pic, idx) => (
                                              <>
                                                <img
                                                  src={pic}
                                                  alt={`Circle ${idx + 1}`}
                                                  className="circle-img borderCircle"
                                                  key={idx}
                                                  onError={handleProfileImageError}
                                                />
                                              </>
                                            )
                                          )}
                                        </div>
                                        <p className="f-10 me-2 ms-1 pointer">
                                          {item?.postInfo?.postReactionContent === null
                                            ? ""
                                            : ` ${item?.postInfo?.postReactionContent?.text}`
                                          } {
                                            item?.postInfo?.likeCount > 3 && (
                                              ` ${t("SignIn.And")} ${item?.postInfo?.postReactionContent?.count - 2
                                              } ${t("SignIn.others")} ${item?.postInfo?.postReactionContent?.contentInfoType
                                              }`
                                            )
                                          }

                                        </p>
                                      </>

                                    )}
                                  </div>
                                </div>
                              )}


                              <div className="d-flex HuzCommentIconWidth">
                                {item?.postInfo?.commentCount === 0 || item?.postInfo?.commentCount === null ? (
                                  ""
                                ) : (
                                  <p
                                    className="f-10 me-2 pointer"
                                    onClick={() => {
                                      openModal(
                                        item?.postInfo?.mediaFilesList?.map(
                                          (file) => file.mediaName
                                        )
                                      );
                                      setSinglePostContent(item);
                                      setSinglePostId(item?.postInfo?.postId);
                                    }}
                                    style={{ color: "#00419f" }}
                                  >
                                    {item?.postInfo?.commentCount} <ChatOutlinedIcon
                                      style={{ color: "#00419f", fontSize: "13px" }} />
                                    {/* {t("Newsfeed.Comment")} */}
                                  </p>
                                )}

                                <p className="f-10">
                                  {item?.postInfo?.shareCount === 0 || item?.postInfo?.shareCount === null
                                    ? ""
                                    : `&  ${item?.postInfo?.shareCount}`} {item?.postInfo?.shareCount === 0 || item?.postInfo?.shareCount === null
                                      ? ""
                                      : <ReplyAllOutlinedIcon className=" ms-1" style={{ color: "#00419f", fontSize: "13px" }} />
                                  }
                                </p>
                              </div>
                            </div>

                            <div className="postengagement">
                              <PostEngagement
                                item={item}
                                setIsLiked={setIsLiked}
                                isLiked={isLiked}
                                postId={item?.postInfo?.postId}
                                AllPostList={AllPostList}
                                postList={postList}
                                setPage={setPage}
                                setPostList={setPostList}
                                page={page}
                                setTotalPages={setTotalPages}
                                totalPages={totalPages}
                                updateLikeCount={updateLikeCount}
                                updateShareCount={updateShareCount}
                                openModal={openModal}
                                setSinglePostContent={setSinglePostContent}
                                setSinglePostId={setSinglePostId}
                                ispostmodalOpen={ispostmodalOpen}
                                setIspostmodalOpen={setIspostmodalOpen}
                                emojiList={emojiList}
                                restrictedViewerToken={restrictedViewerToken}
                                updatePostLike={updatePostLike}
                              />
                            </div>
                            {console.log("responseData", item)}
                            <Comment
                              item={item}
                              isOwnedPost={item?.postInfo?.isOwned}
                              postId={item?.postInfo?.postId}
                              AllPostList={AllPostList}
                              postList={postList}
                              setPage={setPage}
                              setPostList={setPostList}
                              page={page}
                              setTotalPages={setTotalPages}
                              totalPages={totalPages}
                              emojiList={emojiList}
                              setSinglePostContent={setSinglePostContent}
                              openModal={openModal}
                              setImageArray={setImageArray}
                              setInitialSlideIndex={setInitialSlideIndex}
                              setSinglePostId={setSinglePostId}
                              updateLikeCount={updateLikeCount}
                              updateCommentLike={updateCommentLike}
                            />
                          </div>
                        )}
                    </React.Fragment>
                  );
                })}
            </>
          )}
          {hasMoreData ? (
            ""
          ) : (
            <p className="text-center">{t("Newsfeed.No more data available")} </p>
          )}
          {nextBatchLoading && (
            <div className="text-center">
              <img src={post?.loader} width={50} />
            </div>
          )}
        </div>
        <div className="col-md-4 feedAdvertise">
          <div className="feedfixedContainer">
            <div className="featuredScroll">
              {/* <p>Latest code</p> */}
              <div className="advertisementview">
                <div
                  className="advertisementContainer"
                  ref={adContainerRef} // Reference to the ad container
                >
                  {/* The ad will be inserted here */}
                </div>
                <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
              </div>
              <div className="advertisementview">
                <div
                  className="advertisementContainer"
                  ref={adContainerRef1} // Reference to the ad container
                >
                  {/* The ad will be inserted here */}
                </div>
                <h1 className="adText">{t("Newsfeed.Advertisement")}</h1>
              </div>


              {/* <FeedAdvertise /> */}
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <ImageSliderModal
          isOpen={isModalOpen}
          setIsLiked={setIsLiked}
          isLiked={isLiked}
          onRequestClose={closeModal}
          isfollowedComp={isfollowedComp}
          setIsfollowedComp={setIsfollowedComp}
          updateCommentLike={updateCommentLike}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          images={modalImages}
          item={singlePostContent}
          singlepostId={singlepostId}
          setSinglePostId={setSinglePostId}
          updateShareCount={updateShareCount}
          updateLikeCount={updateLikeCount}
          totalPages={totalPages}
          setTotalPages={setTotalPages}
          page={page}
          setPostList={setPostList}
          setPage={setPage}
          postList={postList}
          AllPostListNews={AllPostList}
          PostEngagement={PostEngagement}
          dLike={dLike}
          updateCommentCount={updateCommentCount}
          ispostmodalOpen={ispostmodalOpen}
          setIspostmodalOpen={setIspostmodalOpen}
          openModal={openModal}
          setSinglePostContent={setSinglePostContent}
          setDLike={setDLike}
          updatePostLike={updatePostLike}
          setShowModal={showModal}
          handleLikesCloseModal={handleLikesCloseModal}
          isfollowed={isfollowed}
          setIsfollowed={setIsfollowed}
          initialSlideIndex={initialSlideIndex}
          setInitialSlideIndex={setInitialSlideIndex}
          imageArray={imageArray}
          restrictedViewerToken={restrictedViewerToken}
          updateReplyCommentLike={updateReplyCommentLike}
        />
      )}
      {/* {showModal &&  */}
      <LikesDetails
        showModal={showModal}
        handleLikesCloseModal={handleLikesCloseModal}
        postId={postId}
        postLikedType={postLikedType}
      />
      {/* } */}

      {loading && (
        <div className="row">
          <div className="col-md-12">
            <Loading />
          </div>
        </div>
      )}
      {showToast && (
        <SuccessToast
          show={showToast}
          message={toastMessage}
          onClose={() => setShowToast(false)}
        />
      )}

      {showWarningToast && (
        <WarningToast
          show={showWarningToast}
          message={warningToastMessage}
          onClose={() => setShowWarningToast(false)}
        />
      )}
      {showErrorToast && (
        <ErrorToast
          show={showErrorToast}
          message={ErrorToastMessage}
          onClose={() => setShowErrorToast(false)}
        />
      )}

      <div id="userModal">
        {showUserAuthModal && (
          <UserAuth
            onClose={handleCloseUserAuthModal}
            data={data}
            showUserAuthModal={showUserAuthModal}
            setShowUserAuthModal={setShowUserAuthModal}
          // fetchData={fetchData}
          />
        )}
      </div>

      {showAppliedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are you sure you want to unapply this job?")}</h6>

                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div className="col-md-12 text-end mt-4 d-flex justify-content-center">
                <button
                  type="button"
                  className="mainBtn1"
                  // onClick={() => unapplyNew()}
                  onClick={() => unapplyNew(selectedJobId)}
                >
                  {t("Manage Job.Unapply")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsfeedNew;
